import api from './api'

const expenseService = {
  // 費用類別相關
  getCategories: () => {
    return api.get('/expenses/categories')
  },

  createCategory: (data) => {
    return api.post('/expenses/categories/create', data)
  },

  // 我的費用申請
  getMyClaims: (params) => {
    return api.get('/expenses/my-claims', { params })
  },

  // 所有費用申請（HR）
  getAllClaims: (params) => {
    return api.get('/expenses/claims', { params })
  },

  // 費用申請詳情
  getClaimDetail: (id) => {
    return api.get(`/expenses/claims/${id}`)
  },

  // 建立費用申請
  createClaim: (data) => {
    return api.post('/expenses/claims/create', data)
  },

  // 更新費用申請
  updateClaim: (id, data) => {
    return api.post(`/expenses/claims/${id}/update`, data)
  },

  // 提交費用申請
  submitClaim: (id) => {
    return api.post(`/expenses/claims/${id}/submit`)
  },

  // 核准費用申請
  approveClaim: (id) => {
    return api.post(`/expenses/claims/${id}/approve`)
  },

  // 拒絕費用申請
  rejectClaim: (id, notes) => {
    return api.post(`/expenses/claims/${id}/reject`, { notes })
  },

  // 刪除費用申請
  deleteClaim: (id) => {
    return api.post(`/expenses/claims/${id}/delete`)
  },

  // 標記為已付款
  markPaid: (id, data) => {
    return api.post(`/expenses/claims/${id}/mark-paid`, data)
  },

  // 批次核准
  bulkApprove: (request_ids, comment = '') => {
    return api.post('/expenses/claims/bulk-approve', { request_ids, comment })
  },

  // 批次駁回
  bulkReject: (request_ids, comment = '') => {
    return api.post('/expenses/claims/bulk-reject', { request_ids, comment })
  },

  // 預算管理
  getBudgets: (params) => {
    return api.get('/expenses/budgets', { params })
  },

  createBudget: (data) => {
    return api.post('/expenses/budgets/create', data)
  },

  updateBudget: (id, data) => {
    return api.post(`/expenses/budgets/${id}/update`, data)
  },
}

export default expenseService
